import { FormControl, FormLabel, TextField, Stack, Button, Typography } from '@mui/material'
import { useState } from 'react'

type FilterStringProps = {
  label: string
  defaultValue?: string
  onSubmit: (params: { value: string; label: string }) => void
  onClose: () => void
  placeholder?: string
}

export const FilterString = ({
  label,
  defaultValue,
  onSubmit,
  onClose,
  placeholder,
}: FilterStringProps) => {
  const [value, setValue] = useState<string>(defaultValue ?? '')

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value)
  }

  const handleSubmit = () => {
    if (value.trim() !== '') {
      onSubmit({
        value: value.trim(),
        label: `"${value.trim()}"`,
      })
    }
  }

  const handleClose = () => {
    onClose()
  }

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' && value.trim() !== '') {
      handleSubmit()
    }
  }

  return (
    <Stack sx={{ py: 2, px: 2 }}>
      <FormControl component="fieldset" sx={{ gap: 1, flexDirection: 'column' }}>
        <FormLabel component="legend">
          <Typography variant="subtitle2">{label}</Typography>
        </FormLabel>
        <TextField
          size="small"
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          autoFocus
          sx={{ my: 1 }}
        />
        <Stack direction="row" spacing={1} useFlexGap sx={{ alignSelf: 'flex-end' }}>
          <Button
            variant="contained"
            size="small"
            onClick={handleSubmit}
            disabled={value.trim() === ''}
          >
            Apply
          </Button>
          <Button variant="outlined" size="small" onClick={handleClose}>
            Close
          </Button>
        </Stack>
      </FormControl>
    </Stack>
  )
}
